<template>
    <div>
        <ProductsFilterVariation v-for="variation in variations" :key="variation.id" :variation="variation" :header="header"/>
    </div>
</template>

<script>
    import ProductsFilterVariation from "~/components/Products-filter-variation";

    export default {
        components: {ProductsFilterVariation},
        props: {
            variations: {
                default: () => []
            },
            header: {
                default: true
            }
        }
    }
</script>
